import React, { useEffect } from "react";
import { autocompleteAirports } from "../../api";
import {
  changeDestinationAirport,
  changeFormDirection,
  changeInitialDestinationAirport,
  changeInitialOriginAirport,
  changeOriginAirport,
  changeStartAirports,
} from "./searchFlightsSlice";
import { ConfigSliceState, selectConfig } from "../config/ConfigSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getAirportSuggestionLabel } from "../../utils";
import { RMLocation, Mapper } from "../../types";
import { AppDispatch } from "../../app/store";

function generateAirportOptionFromAutoComplete(response) {
  const requestedAirportCode = response.pattern;
  const foundAirport = response.results.find(
    (airport) => airport.port.code === requestedAirportCode
  );
  if (foundAirport) {
    return {
      code: foundAirport.port.code,
      label: getAirportSuggestionLabel(foundAirport),
    };
  } else {
    return {
      code: requestedAirportCode,
      label: requestedAirportCode,
    };
  }
}

function useFormInitialization() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState(true);
  const { loaded, app, mapper }: ConfigSliceState =
    useAppSelector(selectConfig);
  useEffect(() => {
    (async () => {
      if (loading && loaded) {
        if (
          app.customerType.airport &&
          (mapper.lockOrigin || mapper.lockDestination)
        ) {
          if (app.customerType.airportVersion.single) {
            autocompleteAirports(
              app,
              mapper,
              app.customerType.airportVersion.airport
            ).then((response) => {
              if (response.results && response.results.length > 0) {
                const serverAirport = response.results.find(
                  (airport) =>
                    airport.port.code ===
                    app.customerType.airportVersion.airport
                );
                dispatchAirport(serverAirport, dispatch, mapper);                
              }
            });
          }
          if (app.customerType.airportVersion.multi) {
            const promises = app.customerType.airportVersion.airports.map(
              (airport) => {
                return autocompleteAirports(app, mapper, airport);
              }
            );
            Promise.all(promises).then((results) => {
              const airports = results.map((result) => {
                return generateAirportOptionFromAutoComplete(result);
              });
              dispatch(changeStartAirports(airports));
              if (results.length > 0) {
                const serverAirport = results[0].results.find(
                  (airport) =>
                    airport.port.code ===
                    app.customerType.airportVersion.airports[0]
                );
                dispatchAirport(serverAirport, dispatch, mapper);
              }
            });
          }          
        }
        setLoading(false);
      }
    })();
  }, [loading, loaded, app, mapper, dispatch]);

  return loading;
}

function dispatchAirport(
  airport: RMLocation,
  dispatch: AppDispatch,
  mapper: Mapper
) {
  if (!airport) {
    return;
  }
  airport.readOnly = true;
  if (mapper.lockOrigin) {
    dispatch(changeOriginAirport(airport));
    dispatch(changeInitialOriginAirport(airport));
  }
  if (mapper.lockDestination) {
    dispatch(changeDestinationAirport(airport));
    dispatch(changeInitialDestinationAirport(airport));
  }
  if (mapper.lockFormViaDirection) {
    dispatch(changeFormDirection("via"));
    dispatch(changeOriginAirport(null));
    dispatch(changeInitialOriginAirport(null));
  }
}

export default useFormInitialization;
